var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Live"},[_c('iframe',{attrs:{"id":"frame","frameborder":"0"}}),(_vm.$store.state.desktop && _vm.$store.state.desktop.deviceInfo)?_c('el-button',{staticClass:"goBack",attrs:{"size":"small","type":"text"},on:{"click":_vm.goBackHandle}},[_vm._v("\n    < 返回\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }